import { path } from "../../config";
import { store } from "../../redux/store";
import fetchServer from "../fetchServer";

export async function getUser(userId) {
  var response = {return: 0,msg: "Error",data: null}

  let token = store.getState().user.userData.accessToken;

  await fetchServer({method: 'GET',url: path.api+"/users/"+userId,
    headers: {
      Authorization: `Bearer ${token}`
    } 
  })
  .then((res) => {
    if(res && res?.data?.success) {
      const user =  res.data?.user;
      response = {return: 1,msg: "Successfull",data: user}
    }
    else if(res?.error) response['msg'] = res?.error?.message;
  })
  .catch(e => console.log("Network Error: ",e))
  return response;
}